// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ru7fM","label":"styles_label__3JzlW"};